import PropTypes from 'prop-types';

import { Accordion, Search, CopyToClipboard } from '@utilities/components';
import { useState, useMemo } from 'react';
import { CopyIcon } from '@utilities/icons';

import {
  formatTimestamp,
  processAudioSegmentsIntoSentences,
  highlightText,
} from '../../../../utilities/helpers';

import styles from './_index.module.scss';

const Transcript = ({ aiSummary, audioSegments, onSeekToTimestamp }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const sentences = audioSegments ? processAudioSegmentsIntoSentences(audioSegments) : [];
  const filteredSentences = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return sentences;
    return sentences.filter((sentence) => sentence.text.toLowerCase().includes(query));
  }, [searchQuery, sentences]);

  const handleSegmentClick = (startTimestamp) => {
    if (onSeekToTimestamp) {
      onSeekToTimestamp(startTimestamp);
    }
  };

  return (
    <div className={styles['transcript']}>
      <h3>Transcript</h3>
      <Accordion label="Summary">{aiSummary}</Accordion>
      <div className={styles['transcript-tools']}>
        <Search onChange={setSearchQuery} placeholder="Search" value={searchQuery} />
        <CopyToClipboard
          tooltip="Copy transcript"
          value={filteredSentences.map((s) => s.text).join(' ')}
        >
          <CopyIcon />
        </CopyToClipboard>
      </div>
      <hr className={styles['transcript-divider']} />
      <div className={styles['transcript-auto-generated-label']}>Auto-Generated</div>

      <div className={styles['transcript-content']}>
        {filteredSentences.length > 0 ? (
          filteredSentences.map((sentence, index) => (
            <button
              className={styles['transcript-segment']}
              key={index}
              onClick={() => handleSegmentClick(sentence.start_ts)}
              type="button"
            >
              <span className={styles['transcript-timestamp']}>
                {formatTimestamp(sentence.start_ts)}
              </span>
              <span className={styles['transcript-text']}>
                {highlightText(sentence.text, searchQuery)}
              </span>
            </button>
          ))
        ) : (
          <p className={styles['transcript-no-content']}>No transcript available</p>
        )}
      </div>
    </div>
  );
};

Transcript.propTypes = {
  aiSummary: PropTypes.string,
  audioSegments: PropTypes.arrayOf(
    PropTypes.shape({
      end_time: PropTypes.string,
      id: PropTypes.number,
      items: PropTypes.array,
      start_time: PropTypes.string,
      transcript: PropTypes.string,
    })
  ),
  onSeekToTimestamp: PropTypes.func,
};

export default Transcript;
